module.exports = __webpack_public_path__ + "img/btn_result-text.f74ad8d2.png";